import { memo, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface NodeWrapperProps {
  children: ReactNode;
  selected?: boolean;
  className?: string;
  nodeType?: "trigger" | "action" | "condition" | "agent";
}

export const NodeWrapper = memo(
  ({ children, selected = false, className }: NodeWrapperProps) => {
    return (
      <div
        className={cn(
          "relative bg-white rounded-xl border transition-all duration-200 cursor-pointer shadow-sm",
          !selected && "border-gray-200 hover:shadow-md hover:border-gray-300",
          selected && "border-blue-500 shadow-lg ring-2 ring-blue-500/20",
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

NodeWrapper.displayName = "NodeWrapper";
